import styled from '@emotion/styled';

const Title = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.gray['300'],
  borderRadius: '0.3rem',
  height: '1.8rem',
  width: '85%',
}));

export default Title;
